// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T15:49:51.349Z
// Property: The Club at Heritage (ID: 6767906449167140)
// Collections: 35 amenities, 26 floorplans (live), 40 photos, 41 POIs, 5 reviews, 29 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167140",
  "property_external_id": "1703088",
  "property_zillow_url": "https://www.zillow.com/apartments/sartell-mn/club-at-heritage-1/Ch6FfK/",
  "property_apartments_url": "https://www.apartments.com/the-club-at-heritage-sartell-mn/b38hjs8/",
  "property_google_business_url": "https://www.google.com/maps/place/Club+at+Heritage/data=!4m2!3m1!1s0x0:0x1dd11435887eb65f?sa=X&ved=2ahUKEwiqkp3m04OTAxXbJ0QIHboKNGUQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-club-at-heritage",
  "property_name": "The Club at Heritage",
  "property_website_url": "https://www.clubatheritage.com",
  "property_domain": "https://www.clubatheritage.com",
  "property_address": "720 Roberts Road",
  "property_full_address": "720 Roberts Road, Sartell, MN, 56377",
  "property_address_1": "720 Roberts Rd",
  "property_address_2": null,
  "property_address_city": "Sartell",
  "property_address_state": "MN",
  "property_address_zip_full": null,
  "property_address_zip": "56377",
  "property_address_country": "US",
  "property_address_county": "Stearns County",
  "property_neighborhood_address": "Outlying Stearns County",
  "property_address_latitude": "45.6006",
  "property_address_longitude": "-94.2189",
  "property_email": "clubatheritage@weidner.com",
  "property_phone": "3203628650",
  "property_call_tracking_phone": null,
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Club At Heritage in Sartell, MN, where luxury meets comfort. Choose from stylish one, two, or three-bedroom floor plans, each designed for modern living. Enjoy exclusive amenities like a sparkling pool, fitness center, and dog park. Indulge in relaxation with our spa, clubhouse, and picnic areas!",
  "property_long_description": "Come home to relaxed, elegant living at The Club at HeritageApartment Homes. Our new apartments in south Sartell are in a vibrant area nearCoborn's grocery, the Sartell Community Center, and Meadow Lake Park. The Clubat Heritage is a newly remodeled community with an updated fitness center,clubhouse, and lobby. It's also pet-friendly, offers flexible lease terms, andprovides easy access to Highway 15.Featuring all-in-pricing. One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-6e06-71c9-bad6-47515fbe48c9.webp",
  "property_featured_image_media": {
    "alt_text": "Kitchen and living room area with island, wooden cabinets, stainless steel appliances, and modern decor.",
    "public_id": "019d0215-6e06-71c9-bad6-47515fbe48c9",
    "storage_key": "property/6767906449167140/019d0215-6e06-71c9-bad6-47515fbe48c9.webp",
    "width": 1024,
    "height": 683
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "191",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": "6",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.24083769633508",
  "property_admin_fee": "175",
  "property_application_fee": "50",
  "property_fees_deposit_info": "500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "120",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://clubatheritage.securecafe.com/onlineleasing/the-club-at-heritage/floorplans.aspx",
  "property_resident_portal_url": "https://clubatheritage.securecafenet.com/residentservices/the-club-at-heritage/userlogin",
  "property_apply_now_url": "https://clubatheritage.securecafe.com/onlineleasing/the-club-at-heritage/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-2c7f-71ae-8fcd-29ee916d3a9e.webp",
  "property_primary_logo_media": {
    "alt_text": "The Club at Heritage Apartment Homes logo.",
    "public_id": "019d0216-2c7f-71ae-8fcd-29ee916d3a9e",
    "storage_key": "property/6767906449167140/019d0216-2c7f-71ae-8fcd-29ee916d3a9e.webp",
    "width": 1836,
    "height": 1400
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-4f3e-7427-a9f1-8c5cc7c63303.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Club at Heritage Apartment Homes logo.",
    "public_id": "019d0216-4f3e-7427-a9f1-8c5cc7c63303",
    "storage_key": "property/6767906449167140/019d0216-4f3e-7427-a9f1-8c5cc7c63303.webp",
    "width": 1836,
    "height": 1400
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-ad00-760a-8a55-ca5b8bbdcdfd.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Club at Heritage Apartment Homes logo",
    "public_id": "019d0218-ad00-760a-8a55-ca5b8bbdcdfd",
    "storage_key": "property/6767906449167140/019d0218-ad00-760a-8a55-ca5b8bbdcdfd.webp",
    "width": 640,
    "height": 488
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#8c2232",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1285",
  "property_sqft_min": "657",
  "property_sqft_max": "1285",
  "property_price_range": "1135 - 3180",
  "property_price_min": "1135",
  "property_price_max": "3180",
  "property_available_units": 48,
  "property_facebook_url": "https://www.facebook.com/TheClubAtHeritageApartments",
  "property_instagram_url": "https://www.instagram.com/theclubatheritageapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJP0AXyIFdtFIRX7Z-iDUU0R0",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Club At Heritage",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today",
  "property_home_amenities_blurb": "At Club At Heritage in Sartell, MN, your perfect sanctuary awaits. Choose from spacious one, two, or three-bedroom floor plans that feature modern amenities like vaulted ceilings, stainless steel appliances, and private patios. Enjoy a lifestyle enriched by our clubhouse, fitness center, and serene picnic areas—your ideal living experience starts here.",
  "property_home_floorplans_blurb": "Welcome to Club At Heritage in Sartell, MN, where modern living meets comfort. With a variety of thoughtfully designed floor plans, you'll find the ideal space to suit your lifestyle. Dive into our vibrant community and envision your new home—browse our available apartments today for a fresh start!",
  "property_home_gallery_blurb": "Elevate your lifestyle at Club At Heritage in Sartell, MN, where modern living meets ultimate convenience. Choose from one, two, or three-bedroom floor plans adorned with spacious layouts and upscale amenities. Enjoy relaxing by the pool, gathering with friends in the clubhouse, or unwinding in the on-site spa. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Club At Heritage in Sartell, MN, where spacious one, two, and three-bedroom apartments create your perfect home. Nestled near esteemed educational institutions like Sartell Senior High and Oak Ridge Elementary, our community offers a vibrant lifestyle enriched by knowledge and connection. Dive into the local favorites that surround you!",
  "property_home_reviews_blurb": "At Club At Heritage in Sartell, MN, residents rave about the “friendly community atmosphere and spacious layouts.” Experience a vibrant lifestyle that blends comfort and convenience. See what our residents have to say about living at our community and find your perfect home today!",
  "property_neighborhood_blurb": "At Club At Heritage in Sartell, MN, vibrant living meets community spirit. Nestled near top-notch educational institutions like Oak Ridge Elementary and Sartell Senior High, our apartment community offers an ideal environment for families. Dive into the rich tapestry of local attractions and uncover cherished nearby gems that enhance your lifestyle.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Club At Heritage in Sartell, MN, your lifestyle thrives amidst exceptional amenities. Enjoy spacious one-, two-, and three-bedroom layouts, a pet-friendly atmosphere, and a vibrant clubhouse. Unwind by the pool, stay fit in the gym, or host gatherings around the grill. Experience the ultimate blend of comfort and community.",
  "property_applynow_blurb": "At Club At Heritage in Sartell, MN, your ideal living experience awaits. Choose from spacious one, two, or three-bedroom floor plans, each designed for comfort and style. Enjoy exceptional amenities like a fitness center, luxurious pool, and pet-friendly spaces. Ready to elevate your lifestyle? Lease online today!",
  "property_contactus_blurb": "At Club At Heritage in Sartell, MN, choose from stylish one, two, or three-bedroom floor plans that suit your lifestyle. Each well-designed space offers comfort and modern living. Want to know more? Reach out to our leasing team today and let us help you find your perfect home!",
  "property_faqs_blurb": "At Club At Heritage in Sartell, MN, we offer spacious one, two, and three-bedroom floor plans tailored to your lifestyle. Have questions about our vibrant community? Our FAQs page is packed with insights—from amenities to leasing details—helping you find the information you need for a seamless living experience.",
  "property_floorplans_blurb": "At Club At Heritage in Sartell, MN, we offer thoughtfully designed one, two, and three-bedroom apartments tailored to your lifestyle. Our diverse floor plans combine spacious living with modern amenities, ensuring comfort and style. Browse our available apartment homes and uncover the perfect fit for your new beginning.",
  "property_gallery_blurb": "At Club At Heritage in Sartell, MN, luxury meets comfort in our thoughtfully designed one, two, and three-bedroom apartments. Enjoy top-notch amenities like a state-of-the-art fitness center, inviting pool, and a cozy clubhouse, all while surrounded by the beauty of our pet-friendly community. Picture yourself living here!",
  "property_interactivemap_blurb": "Elevate your lifestyle at Club At Heritage in Sartell, MN. Offering one, two, and three-bedroom floor plans, our community boasts a fitness center, resort-style pool, and inviting clubhouse. With a pet-friendly play area and stunning outdoor spaces, your dream apartment awaits. Check out our interactive community map for details!",
  "property_pets_blurb": "Welcome to Club At Heritage in Sartell, MN, where comfort meets style! Our vibrant community embraces your furry friends—bring up to two pets weighing a combined 120 lbs. Experience a lifestyle enriched by spacious living, modern amenities, and serene surroundings. Your perfect apartment companion awaits!",
  "property_referafriend_blurb": "At Club At Heritage in Sartell, MN, we believe that great friends make great neighbors! Our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—offer the perfect space for your lifestyle. Share the joy of community living by referring a friend today and enhance your home experience!",
  "property_residentaccess_blurb": "Welcome to The Club At Heritage in Sartell, MN, where comfort meets convenience. Choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored to your lifestyle. Sign in to your resident portal for quick rent payments, easy maintenance requests, and exclusive community updates—all at your fingertips!",
  "property_reviews_blurb": "At Club At Heritage in Sartell, MN, our residents rave about the vibrant community spirit and exceptional amenities. One happy tenant shares, “The sense of belonging here is unmatched!” Dive into our reviews to uncover the genuine experiences that make our apartment community a cherished place to call home.",
  "property_created_at": "1771530059592",
  "property_scheduletour_blurb": "At Club At Heritage in Sartell, MN, choose from thoughtfully designed one, two, or three-bedroom apartments that suit your lifestyle. Schedule a tour today and dive into our vibrant community—don’t just take our word for it; hear firsthand from our residents about their exceptional living experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Club At Heritage in Sartell, MN! Our diverse floor plans, including stylish one, two, and three-bedroom options, cater to your unique lifestyle. Keep an eye on your inbox; a dedicated team member will be in touch soon to assist you in finding your perfect home!",
  "property_virtualtours_blurb": "Welcome to Club At Heritage in Sartell, MN, where modern living meets comfort. Choose from thoughtfully designed one, two, or three-bedroom floor plans that suit your lifestyle. Immerse yourself in our vibrant community—take a virtual tour today and envision your new home! Your ideal apartment awaits.",
  "property_copyright": "2026 All Rights Reserved. Club At Heritage",
  "property_seo_title_home": "Club At Heritage |  Apartments in Sartell, MN",
  "property_seo_description_home": "Experience luxury living at Club At Heritage in Sartell, MN! Enjoy spacious floor plans, top-tier amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Sartell, MN Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Club At Heritage in Sartell, MN. Choose from stylish one to three-bedroom floor plans that fit your lifestyle perfectly!",
  "property_seo_title_amenities": "Amenities | Sartell, MN Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Club At Heritage in Sartell, MN! Enjoy spacious floor plans, a fitness center, sparkling pool, and pet-friendly amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in Sartell, MN",
  "property_seo_description_gallery": "Discover the vibrant lifestyle at Club At Heritage, Sartell, MN. Explore photos of your future home with luxurious amenities and spacious layouts!",
  "property_seo_title_virtualtours": "Virtual Tours | Club At Heritage Apartments",
  "property_seo_description_virtualtours": "Discover vibrant living at Club At Heritage in Sartell, MN! Explore our spacious one, two, and three-bedroom apartments with a virtual tour!",
  "property_seo_title_interactivemap": "Interactive Map | Club At Heritage Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Club At Heritage in Sartell, MN. Use our interactive map to explore spacious floor plans and exceptional amenities tailored for you!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Sartell, MN",
  "property_seo_description_neighborhood": "Uncover the charm of Sartell! At Club At Heritage, enjoy vibrant local hotspots and hidden gems right outside your door. Dive into your new neighborhood today!",
  "property_seo_title_contact": "Contact Us | Club At Heritage",
  "property_seo_description_contact": "Connect with the Club At Heritage in Sartell, MN! Inquire about our one to three-bedroom floor plans and let our leasing team assist you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Sartell, MN",
  "property_seo_description_faqs": "Find answers to your questions at Club At Heritage in Sartell, MN. Explore our amenities, floor plans, and discover what makes our community unique!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Sartell, MN",
  "property_seo_description_reviews": "Discover upscale living at Club At Heritage in Sartell, MN. Read resident reviews and experience our premium amenities and vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Sartell, MN",
  "property_seo_description_applynow": "Discover your ideal Sartell retreat! Spacious layouts, resort-style amenities, and a vibrant community await. Apply online and start your new lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | Club At Heritage",
  "property_seo_description_residentaccess": "Log in to the Club At Heritage portal for easy rent payments, maintenance requests, and updates in Sartell, MN. Simplify your home!",
  "property_seo_title_referafriend": "Refer A Friend | Club At Heritage",
  "property_seo_description_referafriend": "Refer a friend to Club At Heritage in Sartell, MN! Enjoy vibrant living, fantastic amenities, and a welcoming community. Great friends make great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Club At Heritage",
  "property_seo_description_scheduletour": "Experience modern living at Club At Heritage in Sartell, MN. Schedule your tour today and step into a vibrant community designed for your lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | Club At Heritage",
  "property_seo_description_privacy": "Your data matters! At Club At Heritage in Sartell, MN, we prioritize your privacy. Check out our policy to see how we protect your information.",
  "property_seo_title_accessibility": "Website Accessibility | Club At Heritage",
  "property_seo_description_accessibility": "Experience inclusive living at Club At Heritage in Sartell, MN. Our commitment to accessibility ensures every resident feels at home in our vibrant community.",
  "property_seo_title_sitemap": "Sitemap | Club At Heritage",
  "property_seo_description_sitemap": "Navigate your way to a vibrant lifestyle at Club At Heritage in Sartell, MN. Check out our sitemap for a clear path to your future home!",
  "property_seo_title_thankyou": "Thank You | Club At Heritage",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of our Club At Heritage team will connect soon. Exciting living awaits you in Sartell, MN! 🌟",
  "property_seo_title_pets": "Pet Policy | Apartments in Sartell, MN",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293660937",
  "amenities": [
    {
      "id": "custom_f8f6b687-4da0-43d3-b699-4ea0f1fc84f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14df738e-df55-458c-a872-c59abf8da48f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ea18a2f-2ec2-4d23-8409-a4709f243444",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc8bb3f4-5f7e-4a57-aba9-7322b14e4c60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17002181-a6d5-4488-ae7f-074191d29c8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ad74f05e-697a-4af7-a3ae-3ce95473e4d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1f82ec4-d18a-42a8-9c4a-e38fc1653902",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Gameroom",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4530db3c-3c17-46ab-bbf2-87b22228bc67",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69c469e0-b351-4e3e-b411-1786c3f11536",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_198523ac-32e6-42a6-8236-dda7577f77bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b4a19cc-29ed-4a3c-a9e5-9c136b9cd5fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_80e06fba-271b-4d5e-be5a-04b9f3ec0470",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e16d69a-7300-4538-83fb-e16b1c5fbb60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Ice Maker*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3da315da-06bc-4ff0-89ec-1842fbeefbd8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio/Balcony*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4fbe2b8f-4892-43cb-88e0-814fa146a0a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Electric Stove",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fdc6084a-3cd5-4693-b4d6-b03f90f7611a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c050b06-051f-4970-9c9b-e375e0850c62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee Station",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_827e7207-1578-43c7-b49c-aa128cb1fcef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Barbecue and Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b40bef73-6b4d-4dbb-81d9-ef107302b15b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "10ft Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c203b72-b398-4981-9fa6-bdbd774af3bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "In‑Home Washer/Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a4fe562-fbe2-4976-9f19-212eb3a86c18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Attached/Detached Garages Available*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d010a84f-281f-42e5-acb4-067793a7acf0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In and Walk‑Through Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f79bb7c5-9afa-4fbe-a80c-54e96012882e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Intercom/Call Box",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2ed527b-dd3c-4cc9-a5ec-64b4a9a11e12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Fire Pit and Seating Area*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e6073d0-aae4-458d-9678-42929803d1e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Theater Room*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_004c21f9-e0f4-46a1-b490-6d17896e9737",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b8e6ce67-9da8-4c84-a182-8d5382f5b8c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_999f6da3-519d-41ca-8797-5700bc9732b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_acbe41af-1074-4657-a6b7-9efe7aff6bf6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8a74474-e099-4a84-81fe-f10469fa4197",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_245d0cde-9a27-48f7-b278-ed93105da331",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5633572f-5915-4076-ada7-f6860b24d33b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66b731e7-ca49-4478-a746-03ca107f0e8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1bbcf3ef-fcb5-4d90-b869-c5199bcdbe5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8dba603a-f0d1-4bb1-a095-ec4bc7b3a694",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_d48221fad18d33a196976712",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-6e06-71c9-bad6-47515fbe48c9.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area with island, wooden cabinets, stainless steel appliances, and modern decor.",
        "public_id": "019d0215-6e06-71c9-bad6-47515fbe48c9",
        "storage_key": "property/6767906449167140/019d0215-6e06-71c9-bad6-47515fbe48c9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious apartment featuring a modern kitchen with an island and stainless steel appliances, seamlessly connected to a well-appointed living area.",
      "link": "false",
      "alt_text": "Kitchen and living room area with island, wooden cabinets, stainless steel appliances, and modern decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (1).jpg"
    },
    {
      "id": "ec_b679f9c4cb30b38fda52a8e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-6e2a-7649-b4bf-c2c65f5447f7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances connected to living area.",
        "public_id": "019d0215-6e2a-7649-b4bf-c2c65f5447f7",
        "storage_key": "property/6767906449167140/019d0215-6e2a-7649-b4bf-c2c65f5447f7.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring beautiful wood cabinetry, a large granite-top island, and stainless steel appliances, seamlessly flowing into the living area for an open-concept feel.",
      "link": "false",
      "alt_text": "Modern kitchen with island and stainless steel appliances connected to living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (2).jpg"
    },
    {
      "id": "ec_97fe6ed449774766ecd46218",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-6e02-7701-b77c-c0c259f1aaaa.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, coffee table, and sliding glass door.",
        "public_id": "019d0215-6e02-7701-b77c-c0c259f1aaaa",
        "storage_key": "property/6767906449167140/019d0215-6e02-7701-b77c-c0c259f1aaaa.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room with a comfortable sofa, a modern coffee table, and a large sliding glass door offering a view of the outdoors. The room is tastefully decorated with accent pillows and artwork.",
      "link": "false",
      "alt_text": "Living room with a white sofa, coffee table, and sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (3).jpg"
    },
    {
      "id": "ec_1028d78a8a226b0e0d08bfd1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-7c36-736e-ae47-73f926a59199.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island with seating.",
        "public_id": "019d0215-7c36-736e-ae47-73f926a59199",
        "storage_key": "property/6767906449167140/019d0215-7c36-736e-ae47-73f926a59199.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring a spacious island with seating, perfect for casual dining or entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (4).jpg"
    },
    {
      "id": "ec_620942a5371045ed500c9f53",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-7a79-756a-8913-6990c8d64f02.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, stainless steel appliances, and a large island.",
        "public_id": "019d0215-7a79-756a-8913-6990c8d64f02",
        "storage_key": "property/6767906449167140/019d0215-7a79-756a-8913-6990c8d64f02.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring ample cabinet space, stainless steel appliances, and a convenient island perfect for meal prep and casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with wood cabinets, stainless steel appliances, and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (5).jpg"
    },
    {
      "id": "ec_27ec9f581d5c449fff64174b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-7c36-736e-ae47-6c12570a8ea7.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a large mirror.",
        "public_id": "019d0215-7c36-736e-ae47-6c12570a8ea7",
        "storage_key": "property/6767906449167140/019d0215-7c36-736e-ae47-6c12570a8ea7.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, two nightstands with lamps, and a full-length mirror to enhance the room's light and space.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (6).jpg"
    },
    {
      "id": "ec_4f4d67a065b57f1763206318",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-7a79-756a-8913-6ca8d3e1f810.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large queen-size bed, upholstered headboard, and decorative pillows.",
        "public_id": "019d0215-7a79-756a-8913-6ca8d3e1f810",
        "storage_key": "property/6767906449167140/019d0215-7a79-756a-8913-6ca8d3e1f810.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax and unwind in the spacious bedroom, featuring a comfortable queen-size bed and ample natural light from the large window. This inviting space is perfect for a restful night's sleep.",
      "link": "false",
      "alt_text": "Cozy bedroom with a large queen-size bed, upholstered headboard, and decorative pillows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (7).jpg"
    },
    {
      "id": "ec_702ce2a0f790821cfc3b571f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-8598-734e-b527-fe46f2a6e873.webp",
      "image_media": {
        "alt_text": "Cozy living room with a sofa, bookshelf, desk, and chair.",
        "public_id": "019d0215-8598-734e-b527-fe46f2a6e873",
        "storage_key": "property/6767906449167140/019d0215-8598-734e-b527-fe46f2a6e873.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room, perfect for unwinding or working from home, featuring a comfortable sofa, stylish bookshelf, and a functional desk area.",
      "link": "false",
      "alt_text": "Cozy living room with a sofa, bookshelf, desk, and chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (8).jpg"
    },
    {
      "id": "ec_7f8764d0f16f58f6da255a98",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d495f-6278-729a-804b-0e092f02ca5b.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
        "public_id": "019d495f-6278-729a-804b-0e092f02ca5b",
        "storage_key": "property/6767906449167140/019d495f-6278-729a-804b-0e092f02ca5b.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and abundant storage with custom cabinetry. Perfect for home chefs and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (9).jpg"
    },
    {
      "id": "ec_43d1cfcc7c00d0101530f423",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d4299-a34a-773e-8186-d20a0b590b00.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and large windows.",
        "public_id": "019d4299-a34a-773e-8186-d20a0b590b00",
        "storage_key": "property/6767906449167140/019d4299-a34a-773e-8186-d20a0b590b00.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax and unwind in the comfortable living room, perfect for entertaining guests or enjoying a quiet evening at home.",
      "link": "false",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (10).jpg"
    },
    {
      "id": "ec_2b542e8474d538679db32381",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d4299-a287-702c-8f6b-bbb764d74a31.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-size bed, nightstands, a dresser, and a chair.",
        "public_id": "019d4299-a287-702c-8f6b-bbb764d74a31",
        "storage_key": "property/6767906449167140/019d4299-a287-702c-8f6b-bbb764d74a31.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully staged bedrooms, perfect for relaxation after a long day.",
      "link": "false",
      "alt_text": "A staged bedroom with a queen-size bed, nightstands, a dresser, and a chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (11).jpg"
    },
    {
      "id": "ec_4c4aaddf91a1e9d0300dc1fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d4299-a286-727d-b615-313b18392226.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, nightstand, and dresser.",
        "public_id": "019d4299-a286-727d-b615-313b18392226",
        "storage_key": "property/6767906449167140/019d4299-a286-727d-b615-313b18392226.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom, featuring a comfortable king-size bed, tasteful decor, and ample natural light.",
      "link": "false",
      "alt_text": "Modern bedroom with a king-size bed, nightstand, and dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (12).jpg"
    },
    {
      "id": "ec_d3e3ae6e2117c855ea123224",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d5716-814a-7694-baf0-9d64b10b103f.webp",
      "image_media": {
        "alt_text": "Updated bathroom with vanity and toilet.",
        "public_id": "019d5716-814a-7694-baf0-9d64b10b103f",
        "storage_key": "property/6767906449167140/019d5716-814a-7694-baf0-9d64b10b103f.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Updated bathroom featuring a vanity with storage and a toilet.",
      "link": "false",
      "alt_text": "Updated bathroom with vanity and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (13).jpg"
    },
    {
      "id": "ec_84c768efe7e5e6d383cb5d33",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d4cc7-76db-7052-a93f-adcf4eb511da.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with blinds on window.",
        "public_id": "019d4cc7-76db-7052-a93f-adcf4eb511da",
        "storage_key": "property/6767906449167140/019d4cc7-76db-7052-a93f-adcf4eb511da.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious living area that opens into a modern kitchen with wood cabinets and stainless steel appliances.",
      "link": "false",
      "alt_text": "Living room and kitchen area with blinds on window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (14).jpg"
    },
    {
      "id": "ec_0eed1d1d01e36fad070fe1a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d4cc7-7718-73f8-b371-f2cbd9d2aef2.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet and a window.",
        "public_id": "019d4cc7-7718-73f8-b371-f2cbd9d2aef2",
        "storage_key": "property/6767906449167140/019d4cc7-7718-73f8-b371-f2cbd9d2aef2.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious living room with neutral carpet, blinds on the window, and a doorway leading to the kitchen.",
      "link": "false",
      "alt_text": "Empty living room with carpet and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (15).jpg"
    },
    {
      "id": "ec_bc02dce2441e370a55aa8303",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d4cc7-75fa-763c-8496-13e1e3edbcc1.webp",
      "image_media": {
        "alt_text": "Empty living room with neutral carpet and a large window.",
        "public_id": "019d4cc7-75fa-763c-8496-13e1e3edbcc1",
        "storage_key": "property/6767906449167140/019d4cc7-75fa-763c-8496-13e1e3edbcc1.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious and inviting living area, perfect for relaxation and entertainment. Features plush carpeting and ample natural light from a large window.",
      "link": "false",
      "alt_text": "Empty living room with neutral carpet and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (16).jpg"
    },
    {
      "id": "ec_9f4be5d99a608bef3e21a1c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-89b9-75ff-96d7-963434c3c81b.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer",
        "public_id": "019d0215-89b9-75ff-96d7-963434c3c81b",
        "storage_key": "property/6767906449167140/019d0215-89b9-75ff-96d7-963434c3c81b.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "In-unit washer and dryer",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (17).jpg"
    },
    {
      "id": "ec_7a5c8daff1a35afd82c7cb59",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-8aaa-71d4-8324-78ca32974e0e.webp",
      "image_media": {
        "alt_text": "Empty living room with large windows and blinds.",
        "public_id": "019d0215-8aaa-71d4-8324-78ca32974e0e",
        "storage_key": "property/6767906449167140/019d0215-8aaa-71d4-8324-78ca32974e0e.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious living area with ample natural light from large windows, perfect for relaxing or entertaining. Features neutral carpeting and neutral wall colors.",
      "link": "false",
      "alt_text": "Empty living room with large windows and blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (18).jpg"
    },
    {
      "id": "ec_b5abe31cb6092596ca853a86",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-9116-7321-b4c7-58f4fbce5284.webp",
      "image_media": {
        "alt_text": "Spacious living room with carpeted floors and natural light streaming through blinds and sliding glass doors.",
        "public_id": "019d0215-9116-7321-b4c7-58f4fbce5284",
        "storage_key": "property/6767906449167140/019d0215-9116-7321-b4c7-58f4fbce5284.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring carpeted floors, large windows, and access to a patio or balcony. A versatile room ready for your personal touch.",
      "link": "false",
      "alt_text": "Spacious living room with carpeted floors and natural light streaming through blinds and sliding glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (19).jpg"
    },
    {
      "id": "ec_431efdc8fa78ba4681dc9be0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-935f-7436-899c-b1fe500137ec.webp",
      "image_media": {
        "alt_text": "Empty apartment living area with built-in cabinets and sliding glass door",
        "public_id": "019d0215-935f-7436-899c-b1fe500137ec",
        "storage_key": "property/6767906449167140/019d0215-935f-7436-899c-b1fe500137ec.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious apartment living area featuring natural light from a sliding glass door and ample storage space in built-in cabinets.",
      "link": "false",
      "alt_text": "Empty apartment living area with built-in cabinets and sliding glass door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (20).jpg"
    },
    {
      "id": "ec_b88555525c2187d2bbdf281c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-9456-77dc-8b20-99d2d5495e79.webp",
      "image_media": {
        "alt_text": "Empty apartment living room and kitchen area with wooden doors and cabinets.",
        "public_id": "019d0215-9456-77dc-8b20-99d2d5495e79",
        "storage_key": "property/6767906449167140/019d0215-9456-77dc-8b20-99d2d5495e79.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious apartment living room and kitchen area featuring modern appliances, wooden doors, and neutral carpeting, ideal for comfortable living.",
      "link": "false",
      "alt_text": "Empty apartment living room and kitchen area with wooden doors and cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (21).jpg"
    },
    {
      "id": "ec_5e717eccc28ec64bdf6cca6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-9452-748c-ac49-3cef6f87c953.webp",
      "image_media": {
        "alt_text": "Kitchen counter with cabinets, sink, and pendant lights. Adjacent living area with large windows.",
        "public_id": "019d0215-9452-748c-ac49-3cef6f87c953",
        "storage_key": "property/6767906449167140/019d0215-9452-748c-ac49-3cef6f87c953.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Modern kitchen with warm wood cabinets and granite countertops, flowing into a spacious living area with abundant natural light.",
      "link": "false",
      "alt_text": "Kitchen counter with cabinets, sink, and pendant lights. Adjacent living area with large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (22).jpg"
    },
    {
      "id": "ec_76271b5854f1aee2e6434754",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-9c39-71fb-837a-1f6466efe66c.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with sliding glass door and vertical blinds.",
        "public_id": "019d0215-9c39-71fb-837a-1f6466efe66c",
        "storage_key": "property/6767906449167140/019d0215-9c39-71fb-837a-1f6466efe66c.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious and bright living area in an apartment, featuring a sliding glass door with vertical blinds and neutral carpeting.",
      "link": "false",
      "alt_text": "Empty apartment living room with sliding glass door and vertical blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (23).jpg"
    },
    {
      "id": "ec_baa7021aff7e16d1c0e45ee9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-9f14-77ab-a7c9-e58a482b0ec3.webp",
      "image_media": {
        "alt_text": "Empty room with blinds on the window and a light fixture on the ceiling.",
        "public_id": "019d0215-9f14-77ab-a7c9-e58a482b0ec3",
        "storage_key": "property/6767906449167140/019d0215-9f14-77ab-a7c9-e58a482b0ec3.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "A bright and airy empty room featuring a large window with blinds, beige carpeting, and a ceiling light. Perfect for personalizing your new space.",
      "link": "false",
      "alt_text": "Empty room with blinds on the window and a light fixture on the ceiling.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (24).jpg"
    },
    {
      "id": "ec_420957ced1d168599b304893",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-9f1e-77ed-8056-3fca00df5a8d.webp",
      "image_media": {
        "alt_text": "Interior of an empty apartment bedroom with a window and a wire shelving unit.",
        "public_id": "019d0215-9f1e-77ed-8056-3fca00df5a8d",
        "storage_key": "property/6767906449167140/019d0215-9f1e-77ed-8056-3fca00df5a8d.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Explore the spacious interiors of your new apartment, featuring a bright bedroom with ample closet space.",
      "link": "false",
      "alt_text": "Interior of an empty apartment bedroom with a window and a wire shelving unit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (25).jpg"
    },
    {
      "id": "ec_19aaf371e24ca5634df8fcbd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-9f3b-70db-89ee-cd23a29055ee.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d0215-9f3b-70db-89ee-cd23a29055ee",
        "storage_key": "property/6767906449167140/019d0215-9f3b-70db-89ee-cd23a29055ee.webp",
        "width": 1022,
        "height": 682
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and shaded umbrellas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (26).jpg"
    },
    {
      "id": "ec_92ca7047221d77e61edafd6d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-a889-7096-8e4f-37aa150f3a6c.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and red chairs in front of apartment building.",
        "public_id": "019d0215-a889-7096-8e4f-37aa150f3a6c",
        "storage_key": "property/6767906449167140/019d0215-a889-7096-8e4f-37aa150f3a6c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Gather around the fire pit or relax under the umbrellas in this inviting outdoor lounge area.",
      "link": "false",
      "alt_text": "Outdoor seating area with fire pit and red chairs in front of apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (27).jpg"
    },
    {
      "id": "ec_92b1256450ec3e51323c1bd4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-a94a-759b-bfc7-d12ca41c37de.webp",
      "image_media": {
        "alt_text": "Lobby with fireplace and seating area",
        "public_id": "019d0215-a94a-759b-bfc7-d12ca41c37de",
        "storage_key": "property/6767906449167140/019d0215-a94a-759b-bfc7-d12ca41c37de.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Cozy lobby with a fireplace, comfortable seating, and large windows overlooking the exterior.",
      "link": "false",
      "alt_text": "Lobby with fireplace and seating area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (28).jpg"
    },
    {
      "id": "ec_91f2052efedcf28a36c0da85",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-ad5d-7098-a6bb-db3db74b1019.webp",
      "image_media": {
        "alt_text": "Modern lobby with seating area and high ceilings.",
        "public_id": "019d0215-ad5d-7098-a6bb-db3db74b1019",
        "storage_key": "property/6767906449167140/019d0215-ad5d-7098-a6bb-db3db74b1019.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious and modern lobby, featuring comfortable seating and a two-story design.",
      "link": "false",
      "alt_text": "Modern lobby with seating area and high ceilings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (29).jpg"
    },
    {
      "id": "ec_e244059959f0f167c9c4ea02",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-ad6a-766b-b8a2-ed1cf5d8003e.webp",
      "image_media": {
        "alt_text": "Lobby seating area with leather chairs and a round coffee table.",
        "public_id": "019d0215-ad6a-766b-b8a2-ed1cf5d8003e",
        "storage_key": "property/6767906449167140/019d0215-ad6a-766b-b8a2-ed1cf5d8003e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting lobby seating area, featuring comfortable leather chairs and a stylish coffee table. A perfect spot to gather or enjoy a quiet moment.",
      "link": "false",
      "alt_text": "Lobby seating area with leather chairs and a round coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (30).jpg"
    },
    {
      "id": "ec_d1b63f55241a14130eefb089",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-b6cc-713e-9d50-856d3382403a.webp",
      "image_media": {
        "alt_text": "Spacious lobby with a curved sofa, coffee tables, and seating area.",
        "public_id": "019d0215-b6cc-713e-9d50-856d3382403a",
        "storage_key": "property/6767906449167140/019d0215-b6cc-713e-9d50-856d3382403a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish and comfortable lobby, perfect for meeting friends or enjoying a quiet moment.",
      "link": "false",
      "alt_text": "Spacious lobby with a curved sofa, coffee tables, and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (31).jpg"
    },
    {
      "id": "ec_00fa230771b9610ad7ce3424",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-b7c3-7018-ae05-343270c1f6ee.webp",
      "image_media": {
        "alt_text": "Kitchen area with a breakfast bar, stools, and stainless steel appliances.",
        "public_id": "019d0215-b7c3-7018-ae05-343270c1f6ee",
        "storage_key": "property/6767906449167140/019d0215-b7c3-7018-ae05-343270c1f6ee.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Enjoy preparing meals in this well-equipped kitchen, featuring a breakfast bar perfect for casual dining and seating for four.",
      "link": "false",
      "alt_text": "Kitchen area with a breakfast bar, stools, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (32).jpg"
    },
    {
      "id": "ec_e2a7ff81d0d2dd8ea204cbc6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-ba46-73ee-8ffd-c6f349a0b369.webp",
      "image_media": {
        "alt_text": "Pool table and kitchen area in the community lounge.",
        "public_id": "019d0215-ba46-73ee-8ffd-c6f349a0b369",
        "storage_key": "property/6767906449167140/019d0215-ba46-73ee-8ffd-c6f349a0b369.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy the community lounge with a pool table and a full kitchen, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Pool table and kitchen area in the community lounge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (33).jpg"
    },
    {
      "id": "ec_38aff639d1e749e21e3a14de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-b970-70b1-a59f-3e1bc88008bb.webp",
      "image_media": {
        "alt_text": "A billiard table sits in a lounge area with a kitchen visible in the background.",
        "public_id": "019d0215-b970-70b1-a59f-3e1bc88008bb",
        "storage_key": "property/6767906449167140/019d0215-b970-70b1-a59f-3e1bc88008bb.webp",
        "width": 1022,
        "height": 680
      },
      "title": "Community",
      "description": "Enjoy a friendly game of billiards in our resident lounge, complete with a full-service kitchen for entertaining.",
      "link": "false",
      "alt_text": "A billiard table sits in a lounge area with a kitchen visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (34).jpg"
    },
    {
      "id": "ec_b9fe7b7a6e7e6884b583488a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-c2bb-712a-8250-900d6b93908f.webp",
      "image_media": {
        "alt_text": "Community lounge with foosball, pool table, and shuffleboard.",
        "public_id": "019d0215-c2bb-712a-8250-900d6b93908f",
        "storage_key": "property/6767906449167140/019d0215-c2bb-712a-8250-900d6b93908f.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in our community lounge, featuring a foosball table, pool table, and shuffleboard for residents to enjoy.",
      "link": "false",
      "alt_text": "Community lounge with foosball, pool table, and shuffleboard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (35).jpg"
    },
    {
      "id": "ec_d5803ed9a9005d8d26311861",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0215-c2c9-717b-9131-0718b56067ac.webp",
      "image_media": {
        "alt_text": "Theater room with plush seating and movie decor.",
        "public_id": "019d0215-c2c9-717b-9131-0718b56067ac",
        "storage_key": "property/6767906449167140/019d0215-c2c9-717b-9131-0718b56067ac.webp",
        "width": 1028,
        "height": 686
      },
      "title": "Community",
      "description": "Enjoy a movie night in our state-of-the-art theater room, complete with comfortable seating and surround sound. A perfect amenity for resident entertainment.",
      "link": "false",
      "alt_text": "Theater room with plush seating and movie decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (36).jpg"
    },
    {
      "id": "ec_92ddaa7961199af6a7d2c438",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d495f-62d8-774c-9d38-6d20a34d30f6.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily apartment building with a large parking lot in the foreground.",
        "public_id": "019d495f-62d8-774c-9d38-6d20a34d30f6",
        "storage_key": "property/6767906449167140/019d495f-62d8-774c-9d38-6d20a34d30f6.webp",
        "width": 1020,
        "height": 681
      },
      "title": "Community",
      "description": "Beautifully designed multifamily apartment building with ample parking, showcasing the building's exterior and surrounding grounds.",
      "link": "false",
      "alt_text": "Exterior of a multifamily apartment building with a large parking lot in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (37).jpg"
    },
    {
      "id": "ec_b3446b5ba69097f1cbd7c0d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d495f-6340-70ce-b619-28542e13d4ff.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with mailboxes and tower feature.",
        "public_id": "019d495f-6340-70ce-b619-28542e13d4ff",
        "storage_key": "property/6767906449167140/019d495f-6340-70ce-b619-28542e13d4ff.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome home to this beautifully maintained community, featuring secure mailboxes and an attractive architectural tower. Enjoy the lush green lawns and well-kept exteriors.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with mailboxes and tower feature.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (38).jpg"
    },
    {
      "id": "ec_0df36f75087a957875ab8ea9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d495f-63f6-70a8-89bc-7db3bb79bfca.webp",
      "image_media": {
        "alt_text": "The Club at Heritage apartment complex exterior with signage.",
        "public_id": "019d495f-63f6-70a8-89bc-7db3bb79bfca",
        "storage_key": "property/6767906449167140/019d495f-63f6-70a8-89bc-7db3bb79bfca.webp",
        "width": 1024,
        "height": 666
      },
      "title": "Community",
      "description": "Welcome to The Club at Heritage, offering beautiful apartment homes. This image showcases the welcoming exterior and clear signage for easy navigation.",
      "link": "false",
      "alt_text": "The Club at Heritage apartment complex exterior with signage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_Club_at_Heritage_Favorites (39).jpg"
    },
    {
      "id": "ec_79af7f7cbcc57b64bdf7a725",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019efd6a-0f2a-770a-9b18-8a0db8a97a2c.webp",
      "image_media": {
        "alt_text": "Stylish seating area in the community lounge with a modern sectional sofa, accent chairs, and a high-top table.",
        "public_id": "019efd6a-0f2a-770a-9b18-8a0db8a97a2c",
        "storage_key": "property/6767906449167140/019efd6a-0f2a-770a-9b18-8a0db8a97a2c.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring comfortable seating and a contemporary design.",
      "link": "false",
      "alt_text": "Stylish seating area in the community lounge with a modern sectional sofa, accent chairs, and a high-top table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Club-at-Heritage-Phase-III-Lobby-Photo-2.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d99a48bc-9a83-4d6a-8ad1-d6e43403a335",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2635 W Division St, St Cloud, MN 56301, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and Texas toast, and they highlight the amazing Cane's sauce. They also like the fast service and friendly staff.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-faa8-70fe-bc7a-15497a7461e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-faa8-70fe-bc7a-15497a7461e0",
        "storage_key": "property/6767906449167140/019d0216-faa8-70fe-bc7a-15497a7461e0.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/mn/saint-cloud/2635-division-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=17478293842633502326&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "45.5536093",
      "poi_longitude": "-94.1901068",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 320-253-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-0dcd583651be",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1RTanHRftFIRdi4RWqVfj_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c6dc2580-fceb-47c0-be85-9306f168d62b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "345 2nd St S, Waite Park, MN 56387, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious prime rib, ribs, and chicken smothered in mushrooms and jack cheese. They highlight the generous portions, reasonable prices, and fast service. They also like the friendly staff and fun atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-facf-7098-96a6-3671cb2d9165.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-facf-7098-96a6-3671cb2d9165",
        "storage_key": "property/6767906449167140/019d0216-facf-7098-96a6-3671cb2d9165.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/minnesota/st-cloud?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7506264123201600493&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "45.5510374",
      "poi_longitude": "-94.2204104",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 320-253-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-0dcd583651be",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIeDvDRdftFIR7buwPXObK2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_32ad078c-b7f0-4a1c-9324-4eb918e05974",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4185 W Division St, St Cloud, MN 56301, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, salads, and peach shakes. They also highlight the fast service and friendly staff.\n\nOther reviews mention the food can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-fab6-7085-9677-281015f497a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-fab6-7085-9677-281015f497a7",
        "storage_key": "property/6767906449167140/019d0216-fab6-7085-9677-281015f497a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/mn/crossroads-center?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15684323105293220717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "45.5537052",
      "poi_longitude": "-94.21331080000002",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 320-251-1669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-0dcd583651be",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5BT3hpftFIRbTt04cPoqdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_e14508b4-4b81-42a0-9969-5c874bbc1ab9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Val's Hamburgers",
      "poi_type": "Restaurants",
      "poi_address": "628 E St Germain St, St Cloud, MN 56304, USA",
      "poi_short_description": "Traditional American hamburgers, milkshakes, soft drinks, & fries in a casual take-out spot.",
      "poi_long_description": "People say this hamburger restaurant serves tasty burgers, fries, and shakes. They highlight the affordable prices, generous portions, and nostalgic 1950s vibe. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-faa8-70fe-bc7a-188ecde616ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-faa8-70fe-bc7a-188ecde616ba",
        "storage_key": "property/6767906449167140/019d0216-faa8-70fe-bc7a-188ecde616ba.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "http://valshamburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2353104922209316810&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vals-hamburgers",
      "poi_latitude": "45.5676115",
      "poi_longitude": "-94.1454619",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 320-251-5775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-0dcd583651be",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_op5YtgtFIRym-Cn3XopyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_c5d88007-3f90-49d2-b7bf-1e25c1c296f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "901 US-10, St Cloud, MN 56304, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "People say this American restaurant serves delicious burgers, cheese curds, and custard. They also highlight the freshly prepared food and the ability to customize toppings.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-feb5-7529-b2ee-35aac55511d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-feb5-7529-b2ee-35aac55511d1",
        "storage_key": "property/6767906449167140/019d0216-feb5-7529-b2ee-35aac55511d1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.culvers.com/restaurants/st-cloud/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=14326266063515832035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "45.5577911",
      "poi_longitude": "-94.1304439",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 320-252-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-0dcd583651be",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-0dcd583651be.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0dr4PlpgtFIR406YuRQf0cY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_43d4573e-aa1f-41e1-bd0e-d9a70099a78f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Crossroads Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4101 W Division St, St Cloud, MN 56301, USA",
      "poi_short_description": "Modern, roomy indoor mall with a standard array of department stores, retail shops & eateries.",
      "poi_long_description": "People say this shopping center has a great food court with reasonably priced options, and they like that it's clean and well-maintained. They also highlight the friendly staff and the variety of stores, making it a great place to find what you need.\n\nSome reviews mention the mall can be a bit crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-ff58-77ca-b883-caf9fbd4f709.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ff58-77ca-b883-caf9fbd4f709",
        "storage_key": "property/6767906449167140/019d0216-ff58-77ca-b883-caf9fbd4f709.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://crossroadscenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14306496614896011433&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crossroads-center",
      "poi_latitude": "45.5562447",
      "poi_longitude": "-94.2101279",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 320-252-2857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb06-757f-a57a-563535e9a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb06-757f-a57a-563535e9a8da",
        "storage_key": "property/6767906449167140/019d0216-cb06-757f-a57a-563535e9a8da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEwffpwVftFIRqYg0R9_iisY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_36a12303-d9b9-459a-8d89-d8d3bc322d1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "251 10th Ave S, Waite Park, MN 56387, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-ff4f-77bf-b2f8-dc96baf14361.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ff4f-77bf-b2f8-dc96baf14361",
        "storage_key": "property/6767906449167140/019d0216-ff4f-77bf-b2f8-dc96baf14361.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3015&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2168111530509962599&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "45.5482024",
      "poi_longitude": "-94.2310941",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 320-240-0075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb06-757f-a57a-563535e9a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb06-757f-a57a-563535e9a8da",
        "storage_key": "property/6767906449167140/019d0216-cb06-757f-a57a-563535e9a8da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJW5z1BjtftFIRZ415KfOtFh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_2276a508-c38c-4e40-94c9-d2e06dbe4ab7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "401 2nd St S, Waite Park, MN 56387, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of items, including lumber, appliances, and plants. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-ff81-7623-8b24-24a9f772b510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-ff81-7623-8b24-24a9f772b510",
        "storage_key": "property/6767906449167140/019d0216-ff81-7623-8b24-24a9f772b510.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/St-Cloud/MN/Waite-Park/56387/2811?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9472398869054083128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "45.5509819",
      "poi_longitude": "-94.2225521",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 320-252-3262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb06-757f-a57a-563535e9a8da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb06-757f-a57a-563535e9a8da",
        "storage_key": "property/6767906449167140/019d0216-cb06-757f-a57a-563535e9a8da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH0heChdftFIRONDHoJW4dIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_77182b04-0763-4d03-a450-eba1c50ffdb5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Coborn's Grocery Store St. Cloud - Cooper Avenue South",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 Cooper Ave S, St Cloud, MN 56301, USA",
      "poi_short_description": "Chain store selling groceries, baked goods, a selection of local items and deli fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-0498-7224-9bdb-8f99ce4c76cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-0498-7224-9bdb-8f99ce4c76cd",
        "storage_key": "property/6767906449167140/019d0217-0498-7224-9bdb-8f99ce4c76cd.webp",
        "width": 1280,
        "height": 774
      },
      "poi_business_url": "https://www.coborns.com/Cobstore2035?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=st-cloud-cooper-website",
      "poi_directions_map_url": "https://maps.google.com/?cid=10203371377252764809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coborns-grocery-store-st-cloud---cooper-avenue-south",
      "poi_latitude": "45.5504894",
      "poi_longitude": "-94.1762427",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 320-251-0484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb06-757f-a57a-59e04882e59c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb06-757f-a57a-59e04882e59c",
        "storage_key": "property/6767906449167140/019d0216-cb06-757f-a57a-59e04882e59c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTZe4MZftFIRiQyKNDWomY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_753e6b37-c62b-40d1-b749-a956a75a8035",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "256 2nd St S, Waite Park, MN 56387, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-0498-7224-9bdb-89dd83e8deae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-0498-7224-9bdb-89dd83e8deae",
        "storage_key": "property/6767906449167140/019d0217-0498-7224-9bdb-89dd83e8deae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.aldi.us/stores/l/mn/waite-park/256-2nd-street-south/l517",
      "poi_directions_map_url": "https://maps.google.com/?cid=1007149336568142534&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "45.548489",
      "poi_longitude": "-94.22073",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb06-757f-a57a-59e04882e59c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb06-757f-a57a-59e04882e59c",
        "storage_key": "property/6767906449167140/019d0216-cb06-757f-a57a-59e04882e59c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6BiyhdftFIRxhrqSfwc-g0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_77dabde2-37d1-4d60-ba11-70ee755f8126",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "St. Cloud State University",
      "poi_type": "Education",
      "poi_address": "720 4th Ave S, St Cloud, MN 56301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-04d8-75ed-8342-d0b72df344bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-04d8-75ed-8342-d0b72df344bc",
        "storage_key": "property/6767906449167140/019d0217-04d8-75ed-8342-d0b72df344bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stcloudstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7417112063816200696&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-cloud-state-university",
      "poi_latitude": "45.548639",
      "poi_longitude": "-94.1515367",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 320-308-0121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb2c-7404-976c-a7f2d5e02784",
        "storage_key": "property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7UudNHJgtFIR-HEH3x_g7mY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_40cebf22-fc66-4499-af93-afb9862826e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "College of Saint Benedict",
      "poi_type": "Education",
      "poi_address": "37 South College Ave S, St Joseph, MN 56374, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-04a6-723a-9fa1-c4ca07377d3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-04a6-723a-9fa1-c4ca07377d3a",
        "storage_key": "property/6767906449167140/019d0217-04a6-723a-9fa1-c4ca07377d3a.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.csbsju.edu/about/college-of-saint-benedict/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8533955126900171964&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "college-of-saint-benedict",
      "poi_latitude": "45.560123",
      "poi_longitude": "-94.3217652",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 320-363-5011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb2c-7404-976c-a7f2d5e02784",
        "storage_key": "property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpw1HytNZtFIRvCQCHPmybnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7dd8042e-5f7d-4594-8d3e-d23e8fe6998b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "St. Cloud Technical & Community College",
      "poi_type": "Education",
      "poi_address": "1540 Northway Dr, St Cloud, MN 56303, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-0971-74bc-9456-b688a9038a8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-0971-74bc-9456-b688a9038a8d",
        "storage_key": "property/6767906449167140/019d0217-0971-74bc-9456-b688a9038a8d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sctcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17005081631675097757&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-cloud-technical--community-college",
      "poi_latitude": "45.5789637",
      "poi_longitude": "-94.1763079",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-222-1009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb2c-7404-976c-a7f2d5e02784",
        "storage_key": "property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtegjDz9etFIRnaKDsKUv_us",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_10bde8b4-944f-4348-8e94-b690e3b7c13d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Great River Regional Library - Saint Cloud",
      "poi_type": "Education",
      "poi_address": "1300 W St Germain St, St Cloud, MN 56301, USA",
      "poi_short_description": "Downtown branch of a regional library chain with computers, play areas, meeting rooms and a bookstore.",
      "poi_long_description": "People say this public library is clean and well-maintained, with lots of natural light and comfortable reading spaces. They also highlight the polite and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-0c59-729e-a6f4-2c5b9727bf0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-0c59-729e-a6f4-2c5b9727bf0a",
        "storage_key": "property/6767906449167140/019d0217-0c59-729e-a6f4-2c5b9727bf0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://griver.org/locations/st-cloud",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002048611932657710&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-river-regional-library---saint-cloud",
      "poi_latitude": "45.5568171",
      "poi_longitude": "-94.1665905",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 320-650-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb2c-7404-976c-a7f2d5e02784",
        "storage_key": "property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ52TkQtFftFIRLljrSef95w0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e8618e76-9ceb-4bd2-b33f-67022e3d8a55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Herb Brooks National Hockey Center",
      "poi_type": "Entertainment",
      "poi_address": "1204 4th Ave S, St Cloud, MN 56301, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this arena is a great place to watch hockey games, especially college hockey, and other sporting events. They highlight the efficient concessions, reasonable prices, and helpful staff. They also like the fun and entertaining vibe, and the free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-0c58-7736-b69c-98f7cd21bf05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-0c58-7736-b69c-98f7cd21bf05",
        "storage_key": "property/6767906449167140/019d0217-0c58-7736-b69c-98f7cd21bf05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stcloudstate.edu/campusrec/facilities/herb-brooks-national-hockey-center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16942841845125292619&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "herb-brooks-national-hockey-center",
      "poi_latitude": "45.5463053",
      "poi_longitude": "-94.1524002",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 320-308-3327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb0m263BgtFIRSyJRIOQQIes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_0a3ed313-5df9-47c1-8a11-ce265eed0547",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Joe Faber Field",
      "poi_type": "Entertainment",
      "poi_address": "5001 Veterans Dr, St Cloud, MN 56303, USA",
      "poi_short_description": "Baseball venue with a crowd-pleasing atmosphere and fireworks after a Friday home game.",
      "poi_long_description": "People say this stadium offers a fun and entertaining baseball experience with a well-maintained natural grass field. They highlight the great atmosphere, decent bathrooms, and fun \"side stuff\" to keep kids entertained. They also like the good prices for tickets, merchandise, and food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-0e89-75e9-bfa1-f7a91be929a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-0e89-75e9-bfa1-f7a91be929a7",
        "storage_key": "property/6767906449167140/019d0217-0e89-75e9-bfa1-f7a91be929a7.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://scsuhuskies.com/sports/2012/6/15/GEN_0615123457.aspx?id=15",
      "poi_directions_map_url": "https://maps.google.com/?cid=16024167778904685965&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "joe-faber-field",
      "poi_latitude": "45.5702154",
      "poi_longitude": "-94.2199087",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 320-255-7223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-2d1f-7023-b961-cb20933821b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0217-2d1f-7023-b961-cb20933821b7",
        "storage_key": "property/6767906449167140/019d0217-2d1f-7023-b961-cb20933821b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2xbEqehetFIRjb3f-rFHYd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_cf6def31-4809-425e-bc5c-4ddea672755f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Summerland Family Fun Park",
      "poi_type": "Entertainment",
      "poi_address": "1050 28th Ave NE, Sauk Rapids, MN 56379, USA",
      "poi_short_description": "Outdoor spot with a huge water slide & bumper boats, plus go karts, mini golf, batting cages & more.",
      "poi_long_description": "People say this amusement park offers fun go-karts, mini golf, and bumper boats. They also highlight the reasonable prices and friendly staff.\n\nOther reviews mention the attractions can be dated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-1144-77ad-a52f-d271dcba6ae4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-1144-77ad-a52f-d271dcba6ae4",
        "storage_key": "property/6767906449167140/019d0217-1144-77ad-a52f-d271dcba6ae4.webp",
        "width": 375,
        "height": 280
      },
      "poi_business_url": "http://www.summerlandfunpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10780792923100260915&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "summerland-family-fun-park",
      "poi_latitude": "45.5820921",
      "poi_longitude": "-94.1038389",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 320-251-0940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSrwDRVhtFIRM6pvYgsSnZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_c7ee13cd-9d64-4eb4-8b45-01f3c11ee6ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Stearns History Museum",
      "poi_type": "Entertainment",
      "poi_address": "235 33rd Ave S, St Cloud, MN 56301, USA",
      "poi_short_description": "Museum highlighting history and culture with exhibits and active military discounts.",
      "poi_long_description": "People say this history museum offers various resources for deep exploration of local history and features cool displays and a library with old books. They highlight the museum's affordable event space, perfect for gatherings, and the beautiful green space surrounding the museum, ideal for picnics and dog walks. They also like the fun, family-friendly way to learn local history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-9488-7676-8a30-0f959dd008df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-9488-7676-8a30-0f959dd008df",
        "storage_key": "property/6767906449167140/019d0216-9488-7676-8a30-0f959dd008df.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.stearnshistorymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8463561872029903416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stearns-history-museum",
      "poi_latitude": "45.5476191",
      "poi_longitude": "-94.2026901",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 320-253-8424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-ce61-74cc-805b-3640240b7499.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-ce61-74cc-805b-3640240b7499",
        "storage_key": "property/6767906449167140/019d0216-ce61-74cc-805b-3640240b7499.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJH3CIiAlftFIROOrhRK6cdHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_bf9518f2-5cdb-49e4-9e81-3fbdc4a2553a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Husky Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1111 3rd Ave S, St Cloud, MN 56301, USA",
      "poi_short_description": "Venue hosting football games with benches, though visitors say it can get cold.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-13d1-76b9-8f17-0c3623601763.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-13d1-76b9-8f17-0c3623601763",
        "storage_key": "property/6767906449167140/019d0217-13d1-76b9-8f17-0c3623601763.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stcloudstate.edu/campusrec/facilities/husky-stadium.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14582126350194069548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "husky-stadium",
      "poi_latitude": "45.5477511",
      "poi_longitude": "-94.1506268",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 320-308-3325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-2d1f-7023-b961-cb20933821b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0217-2d1f-7023-b961-cb20933821b7",
        "storage_key": "property/6767906449167140/019d0217-2d1f-7023-b961-cb20933821b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZXJjSXJgtFIRLFAu9aceXso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_c95e0413-25a4-4c2b-b225-5fb31293f2cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "St. Cloud Area Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2001 Stockinger Dr, St Cloud, MN 56303, USA",
      "poi_short_description": "Nonprofit community fitness center offering a gym, pool, climbing wall, sauna, and track.",
      "poi_long_description": "People say this fitness center offers a wide variety of workout equipment, classes, and activities, including swimming, pickleball, rock climbing, basketball, and group fitness classes. They also highlight the clean facilities, friendly and helpful staff, and positive vibes.\n\nSome reviews mention the pool can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-136c-7312-b741-93f7bb677dfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-136c-7312-b741-93f7bb677dfe",
        "storage_key": "property/6767906449167140/019d0217-136c-7312-b741-93f7bb677dfe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://scymca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=751129418337693543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-cloud-area-family-ymca",
      "poi_latitude": "45.5810837",
      "poi_longitude": "-94.1807306",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 320-253-2664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDa0Llj1etFIRZy9d8DmMbAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_808186b4-a531-4f49-bd6c-45a7616779c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2540 W Division St, St Cloud, MN 56301, USA",
      "poi_short_description": "Chain gym offering tanning beds and massage chairs in the Westgate Shopping Center.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including full platform squat racks, and is always clean. They also highlight the friendly staff and convenient location.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-150d-74bc-97af-fd1f8c6f138c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-150d-74bc-97af-fd1f8c6f138c",
        "storage_key": "property/6767906449167140/019d0217-150d-74bc-97af-fd1f8c6f138c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/st-cloud-mn?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12983680900537178717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.5518952",
      "poi_longitude": "-94.1896165",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 320-774-3711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ4-wb7BftFIRXdqKEf1ML7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a1a9d20e-4fce-44ff-8625-32503584301f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Crunch Fitness - St. Cloud",
      "poi_type": "Health and Wellness",
      "poi_address": "4101 W Division St, St Cloud, MN 56301, USA",
      "poi_short_description": "Fitness center featuring group classes and free weights, plus a sauna, tanning beds and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines and weights, and has lockers with number key pad locks.\n\nOther reviews mention the bathrooms can be poorly maintained and the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-17c4-7624-bb96-475e99adf3ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-17c4-7624-bb96-475e99adf3ff",
        "storage_key": "property/6767906449167140/019d0217-17c4-7624-bb96-475e99adf3ff.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.crunch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2629995134051993674&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---st-cloud",
      "poi_latitude": "45.5548805",
      "poi_longitude": "-94.2088842",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 320-433-3899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKfHiCuJftFIRSsgs3qOefyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a3d0f771-e704-48c6-af40-e4ecf9dc746b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "2860 W Division St Ste 101, St Cloud, MN 56301, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-84b9-7699-b0d4-38448354a76a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-84b9-7699-b0d4-38448354a76a",
        "storage_key": "property/6767906449167140/019d0216-84b9-7699-b0d4-38448354a76a.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/mn/st-cloud/2860-w-division-st?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2837051706275636948&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "45.552808",
      "poi_longitude": "-94.192543",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 320-259-4363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlYaa7q9ftFIR1Kb52X47Xyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_da09cd99-f673-4da8-b6b8-de6c71784218",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Sta-Fit",
      "poi_type": "Health and Wellness",
      "poi_address": "805 Co Rd 120, Sartell, MN 56377, USA",
      "poi_short_description": "Gym offering equipment, classes, a pool, and tennis courts, plus tanning beds and golf simulators.",
      "poi_long_description": "People say this gym offers a variety of amenities, including a sauna, pool, and tennis courts. They also highlight the clean and well-maintained facilities, and the friendly and helpful staff and members.\n\nOther reviews mention the membership can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-19ed-778b-ae74-c27b5056f0e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-19ed-778b-ae74-c27b5056f0e8",
        "storage_key": "property/6767906449167140/019d0217-19ed-778b-ae74-c27b5056f0e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.stafitnow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17236703602158647183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sta-fit",
      "poi_latitude": "45.5871097",
      "poi_longitude": "-94.2201454",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 320-654-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wicDjZctFIRj7dcKZoSNe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ca1776b5-5b9e-4037-9477-591f71cf3da0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Granite City Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2935 2nd St S, St Cloud, MN 56301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-1c13-7623-b994-a6488baaee3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-1c13-7623-b994-a6488baaee3a",
        "storage_key": "property/6767906449167140/019d0217-1c13-7623-b994-a6488baaee3a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://granitecitypet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14546958921576985411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "granite-city-pet-hospital",
      "poi_latitude": "45.5493146",
      "poi_longitude": "-94.1947126",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 320-252-0277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQRwiqRftFIRQ7PL6hAu4ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_88b581fb-f2b0-407d-89ca-cefe8cbfebde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Granite City Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "922 21st Ave NE, St Joseph, MN 56374, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-1e88-71ce-aae4-913059244dd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-1e88-71ce-aae4-913059244dd1",
        "storage_key": "property/6767906449167140/019d0217-1e88-71ce-aae4-913059244dd1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.granitecitygymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18137715279575481989&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "granite-city-gymnastics",
      "poi_latitude": "45.5759221",
      "poi_longitude": "-94.2882656",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 320-251-3547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cb2c-7404-976c-a7f2d5e02784",
        "storage_key": "property/6767906449167140/019d0216-cb2c-7404-976c-a7f2d5e02784.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIxUUMz9ftFIRhX5F9PIbtvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_63dbe5f0-7b02-4775-a5b0-fef4bd25b534",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4180 Thielman Ln, St Cloud, MN 56301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-1e78-733b-b30a-33aa461d1962.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-1e78-733b-b30a-33aa461d1962",
        "storage_key": "property/6767906449167140/019d0217-1e78-733b-b30a-33aa461d1962.webp",
        "width": 1236,
        "height": 695
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/st-cloud-mn/?utm_source=maps&utm_medium=google&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17509079225836272353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "45.5481957",
      "poi_longitude": "-94.2131041",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 320-258-3481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK1M8Jw5ftFIR4Xok8Mm-_PI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_8f16857a-88c8-4b40-8a9c-d72dcc3a7cff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of St. Cloud",
      "poi_type": "Health and Wellness",
      "poi_address": "4106 W Division St, St Cloud, MN 56301, USA",
      "poi_short_description": "Branch of a chain specializing in men's and boys' haircuts with TV sports and a steamed-towel treatment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-203f-739f-a063-707b3bd03f5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-203f-739f-a063-707b3bd03f5b",
        "storage_key": "property/6767906449167140/019d0217-203f-739f-a063-707b3bd03f5b.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-mn-stcloud-mn201?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=11898081101776666764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-st-cloud",
      "poi_latitude": "45.55288609999999",
      "poi_longitude": "-94.209029",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 320-257-2547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW81oTrdftFIRjMAvLLl5HqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_2eb3830f-546b-4f27-b3e5-73e8a586eb71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "CentraCare - St Cloud Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1406 6th Ave N, St Cloud, MN 56303, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-9b7e-7151-a726-4bf254bc79ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-9b7e-7151-a726-4bf254bc79ac",
        "storage_key": "property/6767906449167140/019d0216-9b7e-7151-a726-4bf254bc79ac.webp",
        "width": 1280,
        "height": 515
      },
      "poi_business_url": "https://www.centracare.com/locations/profile/st-cloud-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13715932796747057487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centracare---st-cloud-hospital",
      "poi_latitude": "45.575343",
      "poi_longitude": "-94.1693664",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 320-251-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-cebd-71a8-b9f8-0a3b92c3096d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-cebd-71a8-b9f8-0a3b92c3096d",
        "storage_key": "property/6767906449167140/019d0216-cebd-71a8-b9f8-0a3b92c3096d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnTpNWyRetFIRTwk9YTXIWL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4d984c8e-0807-45fe-ab9a-71c99a389826",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "St. Cloud VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4801 Veterans Dr, St Cloud, MN 56303, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-bd73-747a-b8b9-0e9891f3016b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-bd73-747a-b8b9-0e9891f3016b",
        "storage_key": "property/6767906449167140/019d0216-bd73-747a-b8b9-0e9891f3016b.webp",
        "width": 996,
        "height": 1280
      },
      "poi_business_url": "http://www.va.gov/st-cloud-health-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17939907328558257471&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-cloud-va-medical-center",
      "poi_latitude": "45.5745631",
      "poi_longitude": "-94.2131755",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 320-252-1670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-d23b-740e-b5eb-f68712268400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-d23b-740e-b5eb-f68712268400",
        "storage_key": "property/6767906449167140/019d0216-d23b-740e-b5eb-f68712268400.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXxsV7vFetFIRP1UkZqpa9_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_65be4783-9e4a-43a3-802f-68d40a8fea4a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Quarry Park and Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1802 Co Rd 137, Waite Park, MN 56387, USA",
      "poi_short_description": "Scenic wildlife spot for hiking, biking, picnicking, fishing, swimming & rock-climbing.",
      "poi_long_description": "Visitors say this nature preserve offers hiking trails, swimming areas with cliff jumping, and opportunities for rock climbing and bouldering. They also highlight the unique and beautiful landscape, with its towering rock formations and clear-water quarries, and the park's fascinating history as a working granite quarry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-b7cb-72ff-b74e-4a8cde437be8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-b7cb-72ff-b74e-4a8cde437be8",
        "storage_key": "property/6767906449167140/019d0216-b7cb-72ff-b74e-4a8cde437be8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.stearnscountymn.gov/396/Quarry-Park-Nature-Preserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=1876476672390818028&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quarry-park-and-nature-preserve",
      "poi_latitude": "45.536492",
      "poi_longitude": "-94.241842",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 320-255-6172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-ce28-7527-baa0-da4d96dfc995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-ce28-7527-baa0-da4d96dfc995",
        "storage_key": "property/6767906449167140/019d0216-ce28-7527-baa0-da4d96dfc995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9QYTlNftFIR7Ggpb5eVCho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_e950cae5-91a6-4bb8-b845-fcfd58900ce2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Blackberry Ridge Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3125 Clubhouse Rd, Sartell, MN 56377, USA",
      "poi_short_description": "Beautiful venue for weddings as well as other events, with a golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-240e-73ac-a3ef-333e254923d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-240e-73ac-a3ef-333e254923d0",
        "storage_key": "property/6767906449167140/019d0217-240e-73ac-a3ef-333e254923d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://blackberryridgegolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13203062482703708411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blackberry-ridge-golf-club",
      "poi_latitude": "45.66218200000001",
      "poi_longitude": "-94.243813",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 320-257-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-2ea7-7428-b160-131e1b7fba72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0217-2ea7-7428-b160-131e1b7fba72",
        "storage_key": "property/6767906449167140/019d0217-2ea7-7428-b160-131e1b7fba72.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJxekthrlctFIR-3DXDGCzOrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_373757b7-faef-4760-bb6d-27ef7698b72c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Rivers Edge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 Great Oak Dr, Waite Park, MN 56387, USA",
      "poi_short_description": "Tranquil public park featuring expansive green spaces, athletic amenities & a splash pad.",
      "poi_long_description": "People say this park offers a splash pad, playground, outdoor workout area, pickleball courts, and disc golf. They highlight the shaded areas, convenient access to food and gas, and the relaxed Mississippi riverfront. They also like the well-maintained facilities and the fun atmosphere for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-2628-7310-b71b-06172337753d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-2628-7310-b71b-06172337753d",
        "storage_key": "property/6767906449167140/019d0217-2628-7310-b71b-06172337753d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5131955873163200847&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rivers-edge-park",
      "poi_latitude": "45.5606917",
      "poi_longitude": "-94.2315276",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-ce28-7527-baa0-da4d96dfc995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-ce28-7527-baa0-da4d96dfc995",
        "storage_key": "property/6767906449167140/019d0216-ce28-7527-baa0-da4d96dfc995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwWVGthetFIRT0nfJq1eOEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3eb63c9e-abd8-40f6-bb8e-57cace6dd399",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1725 Kilian Blvd SE, St Cloud, MN 56304, USA",
      "poi_short_description": "Recreational space offering a playground, disc golf, tennis courts, a splash pad, and trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-269e-71d9-b4ff-5c7e44d01344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-269e-71d9-b4ff-5c7e44d01344",
        "storage_key": "property/6767906449167140/019d0217-269e-71d9-b4ff-5c7e44d01344.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ci.stcloud.mn.us/Facilities/Facility/Details/25",
      "poi_directions_map_url": "https://maps.google.com/?cid=11063022219020411092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverside-park",
      "poi_latitude": "45.5455108",
      "poi_longitude": "-94.143043",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 320-650-3055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-ce28-7527-baa0-da4d96dfc995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-ce28-7527-baa0-da4d96dfc995",
        "storage_key": "property/6767906449167140/019d0216-ce28-7527-baa0-da4d96dfc995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVxzC0lhtFIR1CD3AhjAh5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d91db199-ffa3-410c-b106-a9b0324c2073",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Lake George/Eastman Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1101 7th St S, St Cloud, MN 56301, USA",
      "poi_short_description": "Clean park at the city's center featuring a lake, hiking paths and playgrounds.",
      "poi_long_description": "People say this city park offers a walking path around a pond, a splash pad, and playgrounds. They highlight the park is a great place for concerts, family outings, and releasing energy. They also like the beautiful scenery and the presence of swans.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ci.stcloud.mn.us/91/Park-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16418465371350973144&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-georgeeastman-park",
      "poi_latitude": "45.5542645",
      "poi_longitude": "-94.1625308",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 320-255-7277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-ce28-7527-baa0-da4d96dfc995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-ce28-7527-baa0-da4d96dfc995",
        "storage_key": "property/6767906449167140/019d0216-ce28-7527-baa0-da4d96dfc995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdHcetdftFIR2DptOEQb2uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_e5d53c77-14ef-4c08-8ffe-313c5d7c75a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "St. Cloud",
      "poi_type": "Transportation & Transit",
      "poi_address": "555 E St Germain St, St Cloud, MN 56304, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=SCD",
      "poi_directions_map_url": "https://maps.google.com/?cid=7048416171734655842&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-cloud",
      "poi_latitude": "45.567721",
      "poi_longitude": "-94.1488794",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-d1aa-717f-8102-d0d5c2bc9ec2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-d1aa-717f-8102-d0d5c2bc9ec2",
        "storage_key": "property/6767906449167140/019d0216-d1aa-717f-8102-d0d5c2bc9ec2.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xeGHolgtFIRYuNcASoB0WE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_169ed115-af85-4977-9fab-df6ca9300fca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "St. Cloud City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 7th St S, St Cloud, MN 56301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ci.stcloud.mn.us/27/Government",
      "poi_directions_map_url": "https://maps.google.com/?cid=12298871466007724273&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-cloud-city-hall",
      "poi_latitude": "45.5535038",
      "poi_longitude": "-94.1652563",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 320-255-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-d23b-740e-b5eb-f68712268400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-d23b-740e-b5eb-f68712268400",
        "storage_key": "property/6767906449167140/019d0216-d23b-740e-b5eb-f68712268400.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ19ooMPNftFIR8QCUpW9erqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_42bc9899-ceb0-4b63-86ac-54fa83d26ee1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Granite Corporate Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4150 2nd St S, St Cloud, MN 56301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8351572761413694415&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "granite-corporate-center",
      "poi_latitude": "45.5492187",
      "poi_longitude": "-94.2123882",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRcI0MxBftFIRzzPkjy2_5nM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a55a0486-dcd2-437f-a65f-f8606f860c15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Sartell City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "125 Pine Cone Rd N, Sartell, MN 56377, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.sartellmn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7099489340340313648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sartell-city-hall",
      "poi_latitude": "45.62145820000001",
      "poi_longitude": "-94.2285496",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 320-253-2171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-d23b-740e-b5eb-f68712268400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-d23b-740e-b5eb-f68712268400",
        "storage_key": "property/6767906449167140/019d0216-d23b-740e-b5eb-f68712268400.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZJ0sUBctFIRMB6oufBzhmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_c56b1fa0-1baf-4a6a-8308-f55cf16637b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "Creative Memories",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1100 Stearns Dr, Sauk Rapids, MN 56379, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.creativememories.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11508173620931221804&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "creative-memories",
      "poi_latitude": "45.60354470000001",
      "poi_longitude": "-94.1573407",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 320-281-1424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubvB6lP1tFIRLFkgce8-tZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9e28a55d-fbe7-416e-a410-c5dceecb7af0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "poi_name": "McPherson Products",
      "poi_type": "Major Employers & Offices",
      "poi_address": "439 33rd Ave N, St Cloud, MN 56303, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0217-264d-73e0-a6b3-22ab849d316b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0217-264d-73e0-a6b3-22ab849d316b",
        "storage_key": "property/6767906449167140/019d0217-264d-73e0-a6b3-22ab849d316b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mcphersonproducts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=455881506071997702&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcpherson-products",
      "poi_latitude": "45.56188840000001",
      "poi_longitude": "-94.1990372",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 320-371-9110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-c7cc-73b9-80a9-13bd6d58ab39",
        "storage_key": "property/6767906449167140/019d0216-c7cc-73b9-80a9-13bd6d58ab39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzezy1RetFIRBm0XfdCdUwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bdf4b646ab30a1dbb933334d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_07bbec06e7fb27f5ecf978e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d232e97325473c6e8f2aa2fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_25e04caa3d804a1df51b0db2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6df8b8376529bf368ec41769",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_72893426-db98-4e1d-8155-2c25b02e3c64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "rating": "5.0",
      "name": "Melissa Schlickenmayer",
      "text": "I moved in over a year ago and have been absolutely amazed at the staff and their commitment to residents. Every small thing I have ever inquired about has been tended to promptly. The biggest notation that stood out, is I moved in on my own with no assistance. They came by the day of my moving in just checking to see how I was doing. At this time they discovered I had no help. Two of their staff immediately jumped in to help me completely unload the rest of my entire U-Haul! They have also gone above and beyond with some additional personal concerns and issues I had as well. Even after a year here now, they contine to greet my dogs and myself on a first name basis! This is full caring community and they treat this as your home - I highly recommend this place over any others! Know ahead of time also, if you had tendencies to cause disruption in your previous living arrangements, know they will adress you expeditiously here. They care about the atmosphere of this being home and won't tolerate nonsense due to their dedication to their residents. I can not thank them enough for everything they do daily! Absolutely consider this as a top option for best living location, environment, staff and accommodations!",
      "date": "2025-12-02",
      "title": ""
    },
    {
      "id": "custom_ce2548a4-ff83-4358-97d0-c9359c75fee9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "rating": "5.0",
      "name": "Jack Richter",
      "text": "What does the victim of a flooded out home and his 91 year old mother and two little dogs do when they are homeless while their home is being rebuilt and they have lived in 3 hotels and 3 rooms within one hotel??? What do they find? This MIRACULOUS, clean, spacious and immaculately manicured apartment property, staffed by the kindest, most compassionate and caring humans!\nEmily the lovely and ever accomodating property manager has been every bit the most gracious representative of these cozy, well appointed apartments!!! Emily literally goes BEYOND fantastic service in her caring nature. She provided answers immediately and truly cared about what my 91 year old Mom and I went through! Her staff is incredible! Brooke her fantastic, \"Emma Stone\" look alike, always made sure I had my questions answered and she even got Mom and I into an ideal 3 bedroom unit after we had to move from our 2 bedroom due to the mistakes of CRS housing!\nBrooke was as patient and kind as Emily!\nI also worked with Jennifer, another very friendly and caring representative! Jennifer is the newest addition to the team and her warmth and caring are evident!\nI VERY much appreciate the collective energy of these 3 who also have a friendly \"The door is always open\" attitude and no problem is too small OR big for them to handle!\n\nOn top of that, The Club has an incredible housekeeper named Nicole who keeps ALL of the common areas vacuumed, polished and shining bright! Nicole is a huge dog lover...BONUS!!! She fits right in with this lovely Dog and Cat loving community!",
      "date": "2025-12-12",
      "title": ""
    },
    {
      "id": "custom_628d910c-c676-4eff-bc42-e5347e098589",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "rating": "5.0",
      "name": "Naimah Abdinuur",
      "text": "We just did a tour today with the nice and beautiful lady name Jennifer on  11/26 /25. This  woman  was so professional and so friendly! She  show us the property, which was absolutely gorgeous!!!! So hopefully we get an apartment ready for us to rent here in 2026!!! Super excited to live here!!! Thank you Jennifer for your time and support.",
      "date": "2025-11-27",
      "title": ""
    },
    {
      "id": "custom_43a7300a-1bff-4e25-ab88-d07b783e4bac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "rating": "5.0",
      "name": "Andy Mertens",
      "text": "The best apartment complex I've lived in, no doubt! Great apartments, fantastic amenities and a great atmosphere all around! Awesome pool, grill, fireplace, garages and community areas!\n\nDid I mention this place is pet friendly?!? Such a sweet place to raise and meet pet lovers.\n\nIf you need anything Emily and her great staff are always here to help. They always go above and beyond to care care of you.\n\nI'd recommend for any family or single resident. This place has it all!",
      "date": "2023-01-10",
      "title": ""
    },
    {
      "id": "custom_3d57cb37-f062-4e7c-b7d5-6def78f50ffc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "rating": "5.0",
      "name": "Steven Pignato",
      "text": "I have had a great experience at Club at Heritage. It is a calm and quiet apartment facility; everyone is respectful of each other and the area is top notch. Management was rapidly responsive when I was experiencing heating issues; it was resolved within 24 hours (and they followed up to make sure everything was comfortable after the fact). My interactions with faculty/staff have been professional and friendly; they would take the time to answer questions or concerns you may have.\n\nI thoroughly enjoy the out-the-door access to the walking/biking trails in the area. There are several businesses, grocery store, barber, and ice cream parlor, within walking distance. Metro bus lines have stops in the immediate vicinity, offering commuting options for those that work in the St. Cloud area.\n\nI have enjoyed my time being here.",
      "date": "2025-03-07",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_0840c952-883f-48f1-bbf1-5dee4562dc0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-0b65-770e-9a87-931d6112ff5f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious seating area with chairs and tables in a multi-level lobby.",
        "public_id": "019d0218-0b65-770e-9a87-931d6112ff5f",
        "storage_key": "property/6767906449167140/019d0218-0b65-770e-9a87-931d6112ff5f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cZc6iaTnsMK"
    },
    {
      "id": "custom_0c6ba19d-54c9-409e-8d0b-d7a65af7fb00",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-1823-740f-a474-63123fda6049.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern lounge area with high ceilings and large windows",
        "public_id": "019d0218-1823-740f-a474-63123fda6049",
        "storage_key": "property/6767906449167140/019d0218-1823-740f-a474-63123fda6049.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club at Heritage Phase III | Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gqWPBEHQm7g"
    },
    {
      "id": "custom_cb3a2952-cffa-4f51-8a6d-f2b0acd38e3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-2250-777c-a0f0-9d4165ce242c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior common area with a staircase, seating, and decor.",
        "public_id": "019d0218-2250-777c-a0f0-9d4165ce242c",
        "storage_key": "property/6767906449167140/019d0218-2250-777c-a0f0-9d4165ce242c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heritage Village | Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XifusGTnzLg"
    },
    {
      "id": "custom_17745fe1-a742-4eab-b103-a4a3739f1a38",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-0b9b-764a-8452-33cf9da1f6a6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with island, seating, and dining area.",
        "public_id": "019d0218-0b9b-764a-8452-33cf9da1f6a6",
        "storage_key": "property/6767906449167140/019d0218-0b9b-764a-8452-33cf9da1f6a6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | Community Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EfzJppqKoQA"
    },
    {
      "id": "custom_375f50e0-c626-4439-b18f-998b0c392b0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-2df8-739b-b0c7-86a268007724.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with treadmills, elliptical, and weight machines.",
        "public_id": "019d0218-2df8-739b-b0c7-86a268007724",
        "storage_key": "property/6767906449167140/019d0218-2df8-739b-b0c7-86a268007724.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heritage Village 1531 Exercise Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=HcxbGdyaRb6"
    },
    {
      "id": "custom_99388bf1-de1b-4f04-9e41-0fcb5e16b76d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-17d7-738b-b3fd-54239d2a9ab6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Recreation room with foosball table and pool table.",
        "public_id": "019d0218-17d7-738b-b3fd-54239d2a9ab6",
        "storage_key": "property/6767906449167140/019d0218-17d7-738b-b3fd-54239d2a9ab6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heritage Village | Billiards Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KwgJT4t3qsz"
    },
    {
      "id": "custom_d88cb4a6-bbfc-42b3-86d8-80518167a98c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-22f6-738f-8e57-5ec92e5475fc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Children's play area with a playhouse, slide, and basketball hoop.",
        "public_id": "019d0218-22f6-738f-8e57-5ec92e5475fc",
        "storage_key": "property/6767906449167140/019d0218-22f6-738f-8e57-5ec92e5475fc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heritage Village | Play Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5WtQGbfNxZH"
    },
    {
      "id": "custom_65e754c2-8365-4dd0-9f21-39fbebcc2321",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-0b65-770e-9a87-85c2d2c9122d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
        "public_id": "019d0218-0b65-770e-9a87-85c2d2c9122d",
        "storage_key": "property/6767906449167140/019d0218-0b65-770e-9a87-85c2d2c9122d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club at Heritage Phase III | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=d1dCJeAe9nk"
    },
    {
      "id": "custom_a07e615f-0e87-4346-b2e3-52ebfa05b187",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d924a-fd04-7068-88e7-e7876d546894.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d924a-fd04-7068-88e7-e7876d546894",
        "storage_key": "property/6767906449167140/019d924a-fd04-7068-88e7-e7876d546894.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-133 A | Studio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BgZEvEEmXc9"
    },
    {
      "id": "custom_95eeceff-39ab-4c4f-b2f3-3df7a37ee9ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d924a-da2d-707b-8fe3-96501808ffff.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d924a-da2d-707b-8fe3-96501808ffff",
        "storage_key": "property/6767906449167140/019d924a-da2d-707b-8fe3-96501808ffff.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-116 A.1 | Studio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7n7s9RQHrGA"
    },
    {
      "id": "custom_155fb401-7af5-4621-8776-a93a6e01b7f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-2e32-740b-a96f-07a1b600f48f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Open-concept living space with kitchen and walk-in closet.",
        "public_id": "019d0218-2e32-740b-a96f-07a1b600f48f",
        "storage_key": "property/6767906449167140/019d0218-2e32-740b-a96f-07a1b600f48f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club at Heritage | Apt #720-116 | 550 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kPptU2anrsq"
    },
    {
      "id": "custom_7ef8e24d-11a1-4220-ae43-1848ec653812",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d924d-5e66-7059-9906-130faea5c455.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d924d-5e66-7059-9906-130faea5c455",
        "storage_key": "property/6767906449167140/019d924d-5e66-7059-9906-130faea5c455.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heritage Village | B Floor plan | 1 bed 1 bath | Unit 127",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QTmixuqXVk5"
    },
    {
      "id": "custom_539e847a-9e88-4b0f-89e8-500ae1378e7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-1677-760c-8669-bf3fb6fd0b67.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood cabinetry.",
        "public_id": "019d0218-1677-760c-8669-bf3fb6fd0b67",
        "storage_key": "property/6767906449167140/019d0218-1677-760c-8669-bf3fb6fd0b67.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-207 B | 1 BR, 1 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FtMLE6HBhw5"
    },
    {
      "id": "custom_43650b17-1f6f-4d87-8723-16932654affe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-38c7-7108-b5d3-babc1ad1e6e0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d0218-38c7-7108-b5d3-babc1ad1e6e0",
        "storage_key": "property/6767906449167140/019d0218-38c7-7108-b5d3-babc1ad1e6e0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-314 G | 1 BR, 1 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rgAhVSETNkH"
    },
    {
      "id": "custom_a35064b5-bc02-49e7-9933-633fd0faa5f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d9251-7d5e-77aa-863c-2aecdf3b812c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d9251-7d5e-77aa-863c-2aecdf3b812c",
        "storage_key": "property/6767906449167140/019d9251-7d5e-77aa-863c-2aecdf3b812c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-315 B.1 | 1 BR, 1 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kFdyQs4xmdX"
    },
    {
      "id": "custom_e08e0485-1dda-4e97-be80-8900bd22c00e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d924f-3209-710e-83ff-ad8f1b4f44b1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d924f-3209-710e-83ff-ad8f1b4f44b1",
        "storage_key": "property/6767906449167140/019d924f-3209-710e-83ff-ad8f1b4f44b1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-333 A.2 | 1 BR, 1 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gRU5TUr1bg6"
    },
    {
      "id": "custom_5aab1380-9653-4c22-a8a9-fbca93622d25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-1808-742f-92cd-01c37852d61a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Open concept living room and kitchen area with carpet, ceiling fan, and stainless steel appliances.",
        "public_id": "019d0218-1808-742f-92cd-01c37852d61a",
        "storage_key": "property/6767906449167140/019d0218-1808-742f-92cd-01c37852d61a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heritage Village | C Floor plan | 2 bed 1 bath | Unit 219",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=V8DMFUYFAPF"
    },
    {
      "id": "custom_333adc69-e2fe-4572-96f9-610fa5c4b1bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-0b65-770e-9a87-8a26f6c22fc4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and artwork.",
        "public_id": "019d0218-0b65-770e-9a87-8a26f6c22fc4",
        "storage_key": "property/6767906449167140/019d0218-0b65-770e-9a87-8a26f6c22fc4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club at Heritage Phase III | Clemson Model | 2BR, 2BA - 949sf",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DCQ7BbeKWkA"
    },
    {
      "id": "custom_7f7fa500-d255-4b43-83a7-64d6cdfbd03e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d924b-88d4-75be-87af-fbb6751aa010.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d924b-88d4-75be-87af-fbb6751aa010",
        "storage_key": "property/6767906449167140/019d924b-88d4-75be-87af-fbb6751aa010.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-316 C.1 | 2 BR, 2 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=D4Q5KWxPxb4"
    },
    {
      "id": "custom_56ad771f-4839-4c45-80d1-e50ce4969872",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d9250-128d-71ba-9337-759281d4a566.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d9250-128d-71ba-9337-759281d4a566",
        "storage_key": "property/6767906449167140/019d9250-128d-71ba-9337-759281d4a566.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-327 E.1 | 2 BR, 2 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gy6Q8GaMsdk"
    },
    {
      "id": "custom_f5ff8800-1c6d-4d84-90a3-72e817d75276",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-20de-74ea-9930-15c859f8de71.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and living room area with a breakfast bar and sliding glass door leading to a balcony.",
        "public_id": "019d0218-20de-74ea-9930-15c859f8de71",
        "storage_key": "property/6767906449167140/019d0218-20de-74ea-9930-15c859f8de71.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heritage Village | E Floor Plan | 2 bed 2 bath | Unit 312",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rLZ7Z9rYpKi"
    },
    {
      "id": "custom_1f7f98fa-8eb0-4321-a17d-e0783567e4eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-23e5-760d-a5f0-6f4da393b8fa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with dining area and view into a bedroom.",
        "public_id": "019d0218-23e5-760d-a5f0-6f4da393b8fa",
        "storage_key": "property/6767906449167140/019d0218-23e5-760d-a5f0-6f4da393b8fa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heritage Village | Unit 31-202 | 1072 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EdE5ZVG3iK2"
    },
    {
      "id": "custom_2403e510-dd60-4ffc-b226-1de4ee21f3e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-2b69-74f2-98a9-e5423604108e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, stainless steel appliances, and a refrigerator.",
        "public_id": "019d0218-2b69-74f2-98a9-e5423604108e",
        "storage_key": "property/6767906449167140/019d0218-2b69-74f2-98a9-e5423604108e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-201 E | 2 BR, 2 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ipJMcov4kva"
    },
    {
      "id": "custom_7bbabc38-8323-41d7-a483-7780fad48565",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d9252-5d63-729a-a2df-51a4a0e1f752.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d9252-5d63-729a-a2df-51a4a0e1f752",
        "storage_key": "property/6767906449167140/019d9252-5d63-729a-a2df-51a4a0e1f752.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club at Heritage | Apt #720-321 | 803 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tm1YwQDuoBY"
    },
    {
      "id": "custom_80dd15c6-1e35-43d5-aa1b-9b20a1e99b83",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-2dfd-7789-9e15-3ba414ea3e8f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area with dining table",
        "public_id": "019d0218-2dfd-7789-9e15-3ba414ea3e8f",
        "storage_key": "property/6767906449167140/019d0218-2dfd-7789-9e15-3ba414ea3e8f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Heritage Village G Floor Plan (108)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qPeFs68q7fi"
    },
    {
      "id": "custom_d108088e-0803-4857-ae5b-80da6b61d29c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-3636-7693-aeb6-75d24a210d4a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with stainless steel appliances, wood cabinets, and a granite countertop island with a sink.",
        "public_id": "019d0218-3636-7693-aeb6-75d24a210d4a",
        "storage_key": "property/6767906449167140/019d0218-3636-7693-aeb6-75d24a210d4a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-306 C | 2 BR, 2 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mogrmKrdRva"
    },
    {
      "id": "custom_84b5c37d-5df0-44ca-ab38-87145d32083b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-3796-7315-bed2-a65bfd22c6f5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinetry.",
        "public_id": "019d0218-3796-7315-bed2-a65bfd22c6f5",
        "storage_key": "property/6767906449167140/019d0218-3796-7315-bed2-a65bfd22c6f5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-318 D | Accessible 2 BR, 2 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NMCmTxzEHRx"
    },
    {
      "id": "custom_3c5582f3-6f40-43fd-a9b8-fd96339a540f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d0218-391d-775e-85c6-ab56343d1dcc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
        "public_id": "019d0218-391d-775e-85c6-ab56343d1dcc",
        "storage_key": "property/6767906449167140/019d0218-391d-775e-85c6-ab56343d1dcc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-300 E.2 | 2 BR, 2 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=S2xMSwFZPiY"
    },
    {
      "id": "custom_b5fcf717-4fc1-4888-8629-7061f3420de4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167140/019d9252-757f-7265-a78c-746c174350fe.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d9252-757f-7265-a78c-746c174350fe",
        "storage_key": "property/6767906449167140/019d9252-757f-7265-a78c-746c174350fe.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Club At Heritage | 900-335 F | 3 BR, 2 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=y4kZPm4PHCH"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019eb963-4a41-7280-9661-1d6efd50ea40",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Club at Heritage Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "generator",
      "page_item_url": "in-home-washer-dryer-apartments-sartell-mn",
      "search_query": "apartments with in-home washer/dryer sartell mn",
      "category": "Amenity",
      "h1_title": "Apartments with In-Home Washer/Dryer in Sartell",
      "h2_subtitle": "Discover the convenience of apartments with in-home washer/dryers in Sartell, MN. Enjoy modern living at Club At Heritage with premium amenities.",
      "page_copy": "Experience the ultimate in apartment living at Club At Heritage, where modern conveniences meet comfort. Our Sartell, MN apartments feature in-home washer/dryer units, offering you the ease of doing laundry from the comfort of your own space. Embrace hassle-free living and enjoy more free time with this essential amenity right at your fingertips.\n\nLocated in the serene neighborhood of Outlying Stearns County, Club At Heritage offers a range of luxury amenities including stainless steel appliances, vaulted ceilings, and a gated community. Enjoy relaxing afternoons at the spa and the convenience of an in-home washer/dryer, making it easier to balance your busy lifestyle. Choose Club At Heritage for a seamless living experience in Sartell, MN.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Home Washer/Dryer Apartments in Sartell, MN",
      "seo_description": "Find Sartell, MN apartments at Club At Heritage with in-home washer/dryers and enjoy modern amenities like a spa and gated access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-pet-play-area-stearns-county",
      "search_query": "dog-friendly apartments with pet play area stearns county",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Stearns County",
      "h2_subtitle": "Explore dog-friendly apartments with a pet play area in Stearns County. Club At Heritage offers the perfect home for you and your pet.",
      "page_copy": "At Club At Heritage, we understand that pets are part of the family. That's why we offer dog-friendly apartments in Stearns County, complete with a pet play area where your furry friends can romp and play. Our welcoming community ensures that both you and your pets will feel right at home.\n\nSet in the tranquil surroundings of Outlying Stearns County, Club At Heritage not only caters to your pet’s needs but also provides premier amenities for residents. From stainless steel appliances to vaulted ceilings, residents enjoy a comfortable lifestyle. Relax in our spa or enjoy the convenience of a gated community that caters to both pet and human residents alike. Discover the joy of pet-friendly living at Club At Heritage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Pet Play Area",
      "seo_description": "Discover dog-friendly apartments in Stearns County with a pet play area at Club At Heritage. Perfect living for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-spa-sartell-mn",
      "search_query": "luxury apartments with pool and spa in sartell mn",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool & Spa in Sartell",
      "h2_subtitle": "Indulge in luxury apartments with a pool and spa in Sartell, MN. Club At Heritage offers exquisite living with premium features.",
      "page_copy": "Discover the ultimate in luxury living at Club At Heritage, where modern elegance meets exceptional amenities in Sartell, MN. Our luxury apartments invite you to relax and unwind with access to both a pool and a rejuvenating spa, perfect facilities for leisure and relaxation. Enjoy sun-soaked afternoons by the pool or take a comforting dip in the spa after a long day.\n\nNestled in the tranquil Outlying Stearns County, Club At Heritage offers more than just a place to live but a lifestyle to be experienced. Benefit from premium amenities such as stainless steel appliances, vaulted ceilings, and a gated entrance, all designed to enhance your living experience. Choose Club At Heritage, your sanctuary for upscale living in Sartell, MN.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool & Spa in Sartell",
      "seo_description": "Find luxury apartments in Sartell, MN with a pool and spa at Club At Heritage. Experience exceptional living with upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "generator",
      "page_item_url": "apartments-fitness-center-lounge-56377",
      "search_query": "apartments with fitness center and lounge 56377",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center & Lounge 56377",
      "h2_subtitle": "Stay active in apartments with a fitness center and lounge in the 56377 area. Enjoy modern amenities at Club At Heritage.",
      "page_copy": "Club At Heritage offers an exceptional living experience in the heart of Sartell, MN. Our apartments, located in the 56377 zip code, come equipped with a state-of-the-art fitness center, perfect for maintaining an active lifestyle without leaving home. After a good workout, relax in our stylish lounge, designed for comfort and socializing.\n\nSituated in the peaceful Outlying Stearns County, Club At Heritage provides more than just a place to live. We offer a welcoming community with premium features like stainless steel appliances and vaulted ceilings. Our gated community ensures privacy and security, making it an ideal place to call home. Experience the perfect blend of comfort and convenience at Club At Heritage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center & Lounge in 56377",
      "seo_description": "Explore apartments in Sartell, MN with a fitness center and lounge at Club At Heritage. Enjoy modern amenities in the 56377 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "generator",
      "page_item_url": "apartments-private-patio-balconies-outlying-stearns-county",
      "search_query": "apartments with private patio balconies outlying stearns county",
      "category": "Amenity",
      "h1_title": "Apartments with Private Patios in Stearns County",
      "h2_subtitle": "Discover apartments with private patios and balconies in Outlying Stearns County. Enjoy outdoor relaxation at Club At Heritage.",
      "page_copy": "Enjoy the serene atmosphere of Outlying Stearns County with our apartments that feature private patio balconies at Club At Heritage. These personal outdoor spaces offer the perfect setting to unwind with a morning coffee or host an intimate gathering. Revel in the tranquility while still having the convenience of modern living.\n\nClub At Heritage in Sartell, MN, offers more than just picturesque views. Our community is equipped with luxurious amenities, including stainless steel appliances, vaulted ceilings, and a gated entrance. Whether you're enjoying a spa day or simply relaxing on your private balcony, Club At Heritage is your gateway to comfortable living in Outlying Stearns County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Private Patios & Balconies",
      "seo_description": "Find apartments with private patio balconies in Outlying Stearns County at Club At Heritage. Relax and enjoy modern living in style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-sartell-mn",
      "search_query": "one bedroom apartments sartell mn",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Sartell, MN",
      "h2_subtitle": "Explore one bedroom apartments in Sartell, MN at Club At Heritage. Enjoy a blend of comfort and luxury in a serene setting.",
      "page_copy": "Club At Heritage offers stylish one bedroom apartments in the charming city of Sartell, MN. These thoughtfully designed spaces combine comfort and elegance, providing residents with a cozy yet modern living environment. Featuring vaulted ceilings and stainless steel appliances, each apartment is equipped to enhance your lifestyle.\n\nLocated in Outlying Stearns County, Club At Heritage is a gated community that offers residents access to premier amenities such as a spa and pool. Whether you're looking to relax or entertain guests, our one bedroom apartments offer the perfect backdrop for all your needs. Experience the convenience and tranquility of living in Sartell at Club At Heritage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Sartell, MN",
      "seo_description": "Explore stylish one bedroom apartments in Sartell, MN at Club At Heritage. Enjoy modern amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-stearns-county",
      "search_query": "two bedroom apartments stearns county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Stearns County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Stearns County at Club At Heritage. Enjoy modern living with top-tier amenities.",
      "page_copy": "Welcome to Club At Heritage, where you can find spacious two bedroom apartments nestled in the heart of Stearns County. These units provide ample room for families or roommates, paired with modern conveniences like stainless steel appliances and elegant vaulted ceilings.\n\nOur community in Sartell, MN, offers more than just a home; it's a lifestyle choice. Enjoy the luxury of a spa and the security of a gated entrance, making Club At Heritage an ideal setting for comfortable living. Set in the picturesque Outlying Stearns County, you'll enjoy peace and convenience at our well-appointed two bedroom apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Stearns County",
      "seo_description": "Find spacious two bedroom apartments with modern amenities in Stearns County at Club At Heritage. Enjoy comfortable living in Sartell, MN.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167140",
      "source": "generator",
      "page_item_url": "three-bedroom-floorplans-outlying-stearns-county",
      "search_query": "three bedroom floorplans outlying stearns county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floorplans in Stearns County",
      "h2_subtitle": "Explore three bedroom floorplans at Club At Heritage, located in Outlying Stearns County. Perfect for families seeking comfort and style.",
      "page_copy": "Discover the spacious three bedroom floorplans at Club At Heritage, situated in the serene Outlying Stearns County. These thoughtfully designed units are perfect for families or those seeking extra space, offering a harmonious blend of style and functionality. Each apartment features stainless steel appliances, vaulted ceilings, and a private patio or balcony, ideal for both relaxation and entertainment.\n\nSet in the charming city of Sartell, MN, our community provides not only beautiful living spaces but also an array of luxurious amenities. Residents can enjoy the security of a gated entrance and unwind in the spa after a long day. At Club At Heritage, our three bedroom floorplans offer a premium living experience in a tranquil yet accessible location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floorplans in Stearns County",
      "seo_description": "Explore spacious three bedroom floorplans in Outlying Stearns County at Club At Heritage. Perfect blend of comfort and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11308969391"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TZD2KQJS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 5"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "a2427f03-8d59-4f05-9d6b-a31a0db2df18"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a45077e8-b556-41ac-9c6f-e190a4d24966/app.js?property=a45077e8-b556-41ac-9c6f-e190a4d24966&propertyName=The+Club+at+Heritage&channelUuid=33e9a62d-379e-11ee-9425-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IndqMDZxZVBzczdybmxRV253TnNSWEE9PSIsInZhbHVlIjoiekNDbGszOWhQcTk4T2YwcExINllVdz09IiwibWFjIjoiNTBjODM1OWViYmNmOWE0MmIxYTcyNTdmNjlhOTIxM2JkYTk5OGU4OWJkZDg1M2E1NzA4MGYwN2RhYmNkZTA0YSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11308969391",
  "custom_google_gtm_id": "GTM-TZD2KQJS",
  "custom_rollout_phase": "Phase 5",
  "custom_rentgrata_token": "a2427f03-8d59-4f05-9d6b-a31a0db2df18",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a45077e8-b556-41ac-9c6f-e190a4d24966/app.js?property=a45077e8-b556-41ac-9c6f-e190a4d24966&propertyName=The+Club+at+Heritage&channelUuid=33e9a62d-379e-11ee-9425-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IndqMDZxZVBzczdybmxRV253TnNSWEE9PSIsInZhbHVlIjoiekNDbGszOWhQcTk4T2YwcExINllVdz09IiwibWFjIjoiNTBjODM1OWViYmNmOWE0MmIxYTcyNTdmNjlhOTIxM2JkYTk5OGU4OWJkZDg1M2E1NzA4MGYwN2RhYmNkZTA0YSJ9",
  "custom_audioeye_site_id": "e3a21cd0-a454-4e5f-b95f-16b6a5790e3a",
  "custom_audioeye_site_hash": "da8a675bde28a8af721b3ac67236033a"
};

export const generatedAt = '2026-11-02T15:49:51.349Z';
